<template>
  <div class="row">
    <card
      type="tasks"
      class="col-sm"
      style="height: auto; padding-bottom: 30px; overflow-x: auto"
    >
      <template slot="header">
        <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">下载记录</h4>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <base-input>
                <el-input
                 style="width:230px"
                  @blur="onBlur"
                  type="search"
                  class="mb-3 search-input"
                  prefix-icon="el-icon-search"
                  placeholder="搜索账号或下载IP或登录IP"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData">
              <el-table-column label="id" prop="id" :min-width="80">
              </el-table-column>
              <el-table-column label="用户CDK" prop="cdk" :min-width="280">
              </el-table-column>
              <!-- <el-table-column
                label="下载网站"
                prop="site_name"
                :min-width="120"
              >
              </el-table-column> -->
              <el-table-column
                label="下载网站"
                prop="site_name"
                :min-width="120"
                align="center"
              >
                <template slot-scope="{ row }">
                  <badge type="default">{{ row.site_name }}</badge>
                </template>
              </el-table-column>

              <el-table-column
                label="下载链接"
                prop="link"
                :min-width="350"
              >
              </el-table-column>
              <el-table-column
                label="下载ip"
                prop="download_ip"
                :min-width="150"
              >
              </el-table-column>
              <el-table-column label="最后登录ip" prop="last_ip" :min-width="150">
              </el-table-column>

               <el-table-column
                label="下载券类型"
                prop="ticket_type"
                :min-width="80"
                align="center"
              >
                <template slot-scope="{ row }">
                  <badge type="danger" v-if="row.ticket_type == 0"
                    >未&nbsp;知&nbsp;类&nbsp;型</badge
                  >
                  <badge type="default" v-if="row.ticket_type == 1"
                    >通用券</badge
                  >
                  <badge type="info" v-if="row.ticket_type == 2"
                    >精品券</badge
                  >
                  <badge type="warning" v-if="row.ticket_type == 3"
                    >免费券</badge
                  >
                </template>
              </el-table-column>

              <el-table-column
                label="下载时间"
                prop="add_time"
                :min-width="170"
                :formatter="timeFormatter"
              >
              </el-table-column>

               

              <el-table-column
                label="下载类型"
                prop="state"
                :min-width="80"
                align="center"
              >
                <template slot-scope="{ row }">
                  <badge type="default" v-if="row.download_type == 1"
                    >账&nbsp;号&nbsp;下&nbsp;载</badge
                  >
                  <badge type="danger" v-if="row.download_type == 2"
                    >数据库提取</badge
                  >
                  <badge type="info" v-if="row.download_type == 3"
                    >redis提取</badge
                  >
                  <badge type="warning" v-if="row.download_type == 4"
                    >移动云盘提取</badge
                  >
                  <badge type="success" v-if="row.download_type == 5"
                    >123云盘提取</badge
                  >
                </template>
              </el-table-column>

              <el-table-column
                label="查看用户"
                prop="state"
                :min-width="100"
                align="center"
              >
                <template slot-scope="{ row }">
                  <base-button
                    size="sm"
                    style="font-size: 0.685rem"
                    class="animation-on-hover"
                    type="danger"
                    @click="handleQueryUser(row.cdk)"
                    >查看</base-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                显示 {{ from + 1 }} 到 {{ to }} 总数 {{ total }} 条
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </div>
      </template>
    </card>

  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "../../components";
import Swal from "sweetalert2";
import { http } from "../../util/http.js";
import { changeDateFormat, checkTime } from "../../util/utils.js";
import Badge from "@/components/Badge";
import Modal from "@/components/Modal";
import BaseTable from "@/components/BaseTable";

export default {
  components: {
    // BaseTable,
    // Modal,
    Badge,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.pagination.total;
    },
  },
  data() {
    return {
      checkTime,
      changeDateFormat,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      blurredSearchQuery: "",
      propsToSearch: ["cdk", "email", "age"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      modals1: false,
      packageTableData: [],
      packageColumns: [
        "id",
        "package_name",
        "site_name",
        "package_type",
        "download_num",
        "start_time",
        "end_time",
      ],
      cdkTableData: [],
      cdkColumns: [
        "id",
        "cdk",
        "package_name",
        "package_type",
        "use_time",
        "add_time",
        "state",
        "admin_username",
      ],
      payTableData: [],
      payColumns: [
        "id",
        "package_name",
        "order_no",
        "trade_no",
        "pay_ip",
        "create_time",
        "pay_time",
        "pay_type",
        "pay_state",
      ],
    };
  },
  methods: {
    hangleQuery(id) {
      http
        .post(
          "/v1/admin/getAllDownload",
          {
            userId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
          this.packageTableData = res.data.data.packageInfo;
          this.cdkTableData = res.data.data.cdkInfo;
          this.payTableData = res.data.data.payInfo;
          this.modals1 = true;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    handleQueryUser(username) {
      this.$router.push({ path: "/user", query: { username: username } });
    },
    changeUserState(id) {
      http
        .post(
          "/v1/admin/updateUserState",
          {
            userId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "更改失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          this.handleCurrentChange();
          Swal.fire({
            icon: "success",
            title: "更改成功",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    onBlur() {
      if (this.searchQuery == "") {
        this.handleCurrentChange();
      }
      // 当输入框失去焦点时，改变 blurredSearchQuery 的值
      this.blurredSearchQuery = this.searchQuery;
    },
    handleCurrentChange() {
      http
        .post(
          "/v1/admin/getAllDownload",
          {
            currentPage: this.pagination.currentPage,
            perPage: this.pagination.perPage,
            searchQuery: this.searchQuery,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.pagination.total = res.data.data.total;
          this.tableData = res.data.data.tableData;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    timeFormatter(row, column, cellValue) {
      // 在这里处理你的数据
      // row 是整个行数据
      // column 是列数据
      // cellValue 是单元格的值
      // 例如你想将名字转为大写形式：
      if (cellValue == "0001-01-01T00:00:00Z") {
        return "";
      } else {
        cellValue = changeDateFormat(cellValue);
        return cellValue;
      }
    },
    // 清除查询条件
    clearSearchQuery() {
      // this.searchQuery = "";
    },
  },
  mounted() {
    // 页面跳转参数接收
    // 获取 URL 中的 query 参数
    const username = this.$route.query.username;

    if (username) {
      this.searchQuery = username; // 如果有 username 参数，设置为查询条件
      this.handleCurrentChange();
    } else {
      // 如果没有 username 参数，清空 searchQuery
      this.searchQuery = "";
      // this.clearSearchQuery();
      // 立即查询用户信息
      this.handleCurrentChange();
    }
    // 清除 URL 中的查询参数
    if (this.$route.query.username) {
      this.$router.replace({ path: "/user" }); // 这里不携带任何查询参数
    }
  },

  watch: {
    blurredSearchQuery(newVal, oldVal) {
      // 监控搜索
      if (newVal == "") {
        // this.handleCurrentChange();
        return;
      }
      this.handleCurrentChange();
    },
    "pagination.currentPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
    "pagination.perPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
  },
};
</script>
<style scoped lang="scss" >
.pagination-select,
.search-input {
  width: 200px;
}
::v-deep .modal-dialog {
  max-width: 1500px !important;
}
</style>
